import { create } from 'zustand';

type UseSubmitNewRequestInZendeskToaster = {
  isSubmitNewRequestInZendeskSuccess: boolean;
  setIsSubmitNewRequestInZendeskSuccess: (isSubmitNewRequestInZendeskSuccess: boolean) => void;
};

export const useSubmitNewRequestInZendeskToaster = create<UseSubmitNewRequestInZendeskToaster>((set) => ({
  isSubmitNewRequestInZendeskSuccess: false,
  setIsSubmitNewRequestInZendeskSuccess: (isSubmitNewRequestInZendeskSuccess: boolean) =>
    set(() => ({ isSubmitNewRequestInZendeskSuccess })),
}));
